import { MODALS } from 'src/models/ModalModel';
import ModalBase from 'src/components/Modals/ModalBase';
import { MODALS_SIZE } from 'src/models/modal';
import FundraisingEditAmbassadorForm from '../Forms/Fundraising/FundraisingEditAmbassadorForm';

const EditAmbassadorModal = () => (
  <ModalBase
    name={MODALS.editAmbassador}
    size={MODALS_SIZE.small}>
    <FundraisingEditAmbassadorForm />
  </ModalBase>
);

export default EditAmbassadorModal;
